import axios, { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from 'axios';

declare global {
  interface Window {
    REACT_APP_API_URL?: string;
  }
}

const resolveBaseUrl = (): string => {
  if (typeof window !== 'undefined' && window.REACT_APP_API_URL) {
    return window.REACT_APP_API_URL;
  }
  return process.env.REACT_APP_API_URL ?? 'https://api-gestao.vendepay.com/api';
};

export type TokenProvider = () => string | null;
export type UnauthorizedHandler = () => void;

let getToken: TokenProvider = () => null;
let onUnauthorized: UnauthorizedHandler = () => undefined;

export const configureApiAuth = (
  tokenProvider: TokenProvider,
  unauthorizedHandler: UnauthorizedHandler,
) => {
  getToken = tokenProvider;
  onUnauthorized = unauthorizedHandler;
};

export const api: AxiosInstance = axios.create({
  baseURL: resolveBaseUrl(),
  timeout: 15000,
});

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = getToken();
  if (token) {
    config.headers.set?.('Authorization', `Bearer ${token}`);
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      onUnauthorized();
    }
    return Promise.reject(error);
  },
);
